import styled, { css } from "styled-components";
import { optionalPadding } from "../../utils/helpers/mixins";

export const PrimaryHeader = styled.h1.attrs((props) => ({
  as: props.as ?? "h1",
  className: "primary-header"
}))(({ theme }) => css`
  font-size: 20px;
  font-weight: 400;
  line-height: 2;
  color: ${theme.palette.text.body};
  ${optionalPadding}

  @media only screen and (min-width: ${theme.breakpoints.M}) {
    font-size: 25px;
    text-align: center;
  }
`);